import {
  Directive,
  Input,
  Output,
  HostListener,
  ElementRef,
  Renderer2,
  EventEmitter
} from '@angular/core';
import { FocusManagerService } from './focus-manager.service';

@Directive({
  selector: '[focus-item]',
  exportAs: 'focusItem'
})
export class FocusItemDirective {
  @Output() itemFocus = new EventEmitter<any>();
  @Output() itemBlur = new EventEmitter<any>();
  @Input('focus-item-class') focusItemClass: string = 'focus';
  focus: boolean = false;
  constructor(
    private focusManagerService: FocusManagerService,
    private elRef: ElementRef,
    private renderer: Renderer2
  ) {}
  ngOnInit() {
    this.focusManagerService.onChange.subscribe(path => {
      let focus = path.includes(this);
      if (this.focus !== focus) {
        this.focus = focus;
        this.toggleClass(this.focus);
        this.emitEvent(this.focus);
      }
    });
  }
  toggleClass(bool: boolean) {
    if (bool)
      this.renderer.addClass(this.elRef.nativeElement, this.focusItemClass);
    else
      this.renderer.removeClass(this.elRef.nativeElement, this.focusItemClass);
  }
  emitEvent(bool: boolean) {
    if (bool) this.itemFocus.next(null);
    else this.itemBlur.next(null);
  }

  // lastFocusEvent:MouseEvent;
  @HostListener('click', ['$event'])
  onClick($event: MouseEvent) {
    this.focusManagerService.push(this);
  }
}
